import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OpdComponent} from './opd.component';
import {DoctorScheduleChartModule} from './doctor-schedule-chart/doctor-schedule-chart.module';
import {ListofTokenGeneratedModule} from './listof-token-generated/listof-token-generated.module';
import {PortalAppointmentListModule} from './portal-appointment-list/portal-appointment-list.module';

const routes: Routes = [
    {
        path: 'opd', component: OpdComponent,
        children: [
            {
                path: 'patientregistration',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {
                path: 'patientregistration/:user_id',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {
                path: 'portalpatientregistration/:appointment_portal_id',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {
                path: 'patientregistration/:user_id/:visit_id',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {path: 'appointment', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 'doctorschedulechart', loadChildren: './doctor-schedule-chart/doctor-schedule-chart.module#DoctorScheduleChartModule'},
            /* {path: 'todaysdoctorschedulechart', loadChildren: './todays-doctor-schedule-chart/todays-doctor-schedule-chart.module#TodaysDoctorScheduleChartModule'},*/
            {path: 'existing-appointment', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 'reschedule-appointment/:app_id', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 're-schedule-appointment', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 'appointment-list', loadChildren: './appointment-list/appointment-list.module#AppointmentListModule'},
            {path: 'portal-appointment-list', loadChildren: './portal-appointment-list/portal-appointment-list.module#PortalAppointmentListModule'},
            {
                path: 'patientregistrationlist',
                loadChildren: './registered-patient/registered-patient.module#RegisteredPatientModule'
            },
            {path: 'opdipd', loadChildren: './trn-opd-ipd/trn-opd-ipd.module#TrnOpdIpdModule'},
            {path: 'queue', loadChildren: './queue-management/queue-management.module#QueueManagementModule'},
            {path: 'queue-by-dept', loadChildren: './queue-management-by-dept/queue-management.module#QueueManagementByDeptModule'},
            {path: 'generate-token', loadChildren: './generate-token/generate-token.module#GenerateTokenModule'},
            {path: 'listoftoken', loadChildren: './listof-token-generated/listof-token-generated.module#ListofTokenGeneratedModule'},
            {path: 'allpatientqueue', loadChildren: './all-patient-queue/all-patient-queue.module#AllPatientQueueModule'},
            {
                path: 'patientregistration/emergency/:user_id/:visit_id',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {path: 'regpatientvisit/:visit_id/:typeCheck/:NewOrExit', loadChildren: './reg-patient-visit/reg-patient-visit.module#RegPatientVisitModule'},
            {path: 'patientregistrationlistnew', loadChildren: './patient-registration-list/patient-registration-list.module#PatientRegistrationListModule'},
            {path: 'regpatientvisit/:visit_id/:typeCheck/:NewOrExit/:appointmentId', loadChildren: './reg-patient-visit/reg-patient-visit.module#RegPatientVisitModule'},
            {path: 'regpatientvisit/:visit_id/:typeCheck/:NewOrExit/:admissionrequestId', loadChildren: './reg-patient-visit/reg-patient-visit.module#RegPatientVisitModule'},
            {path: 'regpatientvisittransfer/:visit_id/:typeCheck/:NewOrExit/:transfer', loadChildren: './reg-patient-visit/reg-patient-visit.module#RegPatientVisitModule'},
            {
                path: 'admReqpatientregistration/:AdmissionReq_user_id',
                loadChildren: './patient-registration/patient-registration.module#PatientRegistrationModule'
            },
            {path: 'reschedule-appointment/:app_id', loadChildren: './trn-appointment/trn-appointment.module#TrnAppointmentModule'},
            {path: 'followup-list', loadChildren: './followup-list/followup-list.module#FollowupListModule'},

        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/opd/opd.routing.ts